import angular from 'angular';
import uiRouter from 'angular-ui-router';

import ActivePromoMessageComponent from './active_promo.component';

const activePromoMessageModule = angular.module('tinaba.components.messageOutbound.active_promo', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider.state('messageOutbound.active_promo', {
    url: '/active_promo',
    template: '<active_promo-message></active_promo-message>'
  });
})

.component('activePromoMessage', ActivePromoMessageComponent);

export default activePromoMessageModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/messageOutbound/active_promo/active_promo.js
 **/